module.exports = "./src/client/ui/layout/header-rogante/image/logo-space.png?c252303ce1c5854d5daea4b5fe30de58";